import { ReactNode } from 'react';

export enum SidebarPosition {
  Left = 'Left',
  Right = 'Right',
}

export default interface ILayoutWithSidebar {
  header: ReactNode;
  main: ReactNode;
  sidebar?: ReactNode;
  leftSidebar?: ReactNode;
  sidebarSize?: string;
  headerClassName?: string;
  mainClassName?: string;
  mainContentClassName?: string;
  sidebarClassName?: string;
  rootClassName?: string;
  leftSidebarClassName?: string;
}
